import React, { Component } from 'react'
import { getProjects } from '../../api/butterCMS'
import { ContentBlock } from '../../components'
import { LoadingSpinner } from '../../components/Global'
import ProjectLink from '../../components/Project/ProjectLink'

class ProjectGrid extends Component {
    constructor(props) {
        super(props)

        this.state = {
            pager: {
                count: 0,
                next_page: 0,
                previous_page: 0,
                current_page: 1,
                page_size: this.props.pageSize
            },
            projects: []
        }

        this.loadMore = this.loadMore.bind(this)
    }

    componentDidMount() {
        const { pager } = this.state
        const { current_page, page_size } = pager
        this._loadProjects(current_page, page_size)
    }

    _loadProjects(current_page, page_size) {
        getProjects({ page: current_page, page_size}).then(({ data, meta }) => {
            const currentProjects = this.state.projects
            const projects = data.projects

            this.setState({
                ...this.state,
                projects: currentProjects.concat(projects),
                pager: { current_page, page_size, ...meta }
            })
        })
    }

    loadMore(e) {
        e.preventDefault()

        const { next_page, page_size } = this.state.pager
        this._loadProjects(next_page, page_size)
    }

    render() {
        const { pager, projects } = this.state

        return (
            <div>
                {!projects.length ? 
                    <ContentBlock className="content-block content-block--fluid u-no-padding c-work-grid">
                        <ProjectLink isPlaceholder={true} />
                        <ProjectLink isPlaceholder={true} />
                        <ProjectLink isPlaceholder={true} />
                    </ContentBlock>
                : 
                    <ContentBlock className="content-block content-block--fluid u-no-padding c-work-grid">
                        {projects.map((project, k) => {
                            return (
                                <ProjectLink project={project} key={k} />
                            )
                        })}

                        {pager.next_page ? 
                            <div className="c-work-grid__pager u-text-center">
                                <a className="u-unstyled u-down-arrow-link" href="#" onClick={this.loadMore}>Oh, there's more!</a>
                            </div>
                        : ''}
                    </ContentBlock>
                }
            </div>
        )
    }
}

export default ProjectGrid


// WEBPACK FOOTER //
// ./src/pages/projects/grid.js